import { useQuery, useMutation } from '@tanstack/react-query';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import firebaseApp from '../firebase-app';
import { getTeamDataPath } from '../utils/paths';
import { TeamData } from '../components/common/team/types';

const getTeamData = async (teamAbbrv: string): Promise<TeamData> => {
  const team = await getDoc(doc(firebaseApp.db, getTeamDataPath(teamAbbrv)));
  return team?.data() as TeamData;
};

export default function useTeamData(params: { teamAbbrv: string }) {
  const { teamAbbrv } = params;
  const query = useQuery({
    queryKey: ['team-data', teamAbbrv],
    queryFn: async () => {
      const teamData = await getTeamData(teamAbbrv);

      return teamData;
    },
    refetchOnWindowFocus: false,
  });
  return {
    query,
    mutation: useMutation({
      mutationFn: async (newData: Partial<TeamData>) => {
        const ref = doc(firebaseApp.db, getTeamDataPath(teamAbbrv));

        const res = await updateDoc(ref, newData);
        return res;
      },
      onSuccess() {
        query.refetch();
      },
    }),
  };
}
